"use client"

import { useLocation } from "react-router-dom"
import { LogOut } from "lucide-react"
import { logout } from "@/services/auth.ts"
import { getStoredUser } from "@/services/auth-storage.ts"
import { NotificationBell } from "@/components/NotificationBell.tsx"

const titles: [string, string][] = [
  ["/inventory/security-doors", "Αποθήκη — Θωρακισμένες Πόρτες"],
  ["/inventory/interior-doors", "Αποθήκη — Εσωτερικές Πόρτες"],
  ["/inventory", "Αποθήκη"],
  ["/orders/security-doors/new", "Νέα Παραγγελία"],
  ["/orders/interior-doors/new", "Νέα Παραγγελία"],
  ["/orders/security-doors", "Παραγγελίες — Θωρακισμένες Πόρτες"],
  ["/orders/interior-doors", "Παραγγελίες — Εσωτερικές Πόρτες"],
  ["/production", "Παραγωγή"],
  ["/customers", "Πελάτες"],
  ["/settings", "Ρυθμίσεις"],
]

function titleFor(pathname: string): string {
  if (pathname === "/") return "Αρχική"
  const match = titles.find(([prefix]) => pathname.startsWith(prefix))
  return match ? match[1] : "Douskas Doors"
}

export function Navbar() {
  const { pathname } = useLocation()
  const user = getStoredUser()

  async function handleLogout() {
    await logout()
    // Πλήρης πλοήγηση (όχι SPA): αδειάζει και το react-query cache από τη μνήμη.
    window.location.assign("/login")
  }

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between bg-background/80 backdrop-blur-md border-b border-border px-4 lg:px-8">
      <h2 className="text-[15px] font-semibold tracking-tight">{titleFor(pathname)}</h2>
      <div className="flex items-center gap-3">
        {user && <span className="hidden text-sm text-muted-foreground sm:inline">{user.name}</span>}
        <NotificationBell />
        <button
          type="button"
          onClick={handleLogout}
          title="Αποσύνδεση"
          className="flex size-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        >
          <LogOut className="size-4" />
        </button>
      </div>
    </header>
  )
}
